import React, { createContext, useContext } from "react";
import { useBrand } from "../hooks.js";
const BrandContext = createContext(null);
function BrandProvider({ children, brandService }) {
  const brandContextValue = useBrand(brandService);
  return /* @__PURE__ */ React.createElement(BrandContext.Provider, { value: brandContextValue }, children);
}
function useBrandContext() {
  const context = useContext(BrandContext);
  return context;
}
export {
  BrandContext,
  BrandProvider,
  useBrandContext
};
//# sourceMappingURL=BrandProvider.js.map
